import React from 'react'
import {
    CheckCircleRounded,
    DescriptionRounded,
    PlayArrowRounded,
} from '@mui/icons-material'
import { Box, LinearProgress, useTheme } from '@mui/material'
import { TEST, VIDEO } from '../../../../utils/constants'
import {
    SectionDetailsState,
    SectionState,
    UserTopicState,
} from '../../../../features/types'

interface Props {
    section: SectionState
    isLast: boolean
    selectedSection: SectionState
    isFetchingSectionDetails: boolean
    isFetchingSections: boolean
    sectionDetails: SectionDetailsState
    selectedTopic: UserTopicState
    selectedTopicSections: SectionState[]
    currentSectionIndex: number
    userSubjectEnrollId: number
    onPreviousSection: () => void
    onNextSection: () => void
    handleSelect: () => void
}

const Section: React.FC<Props> = ({
    section = null,
    selectedSection = null,
    isLast,
    handleSelect,
}) => {
    const theme = useTheme()

    const styles = {
        wrapper: {
            display: 'flex',
            alignItems: 'center',
            p: 1,
            borderBottom: isLast ? '' : `1px solid ${theme.palette.grey[200]}`,
            cursor: 'pointer',
            background: section?.id === selectedSection?.id ? '#F9FAFB' : null,
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },
        typeIcon: {
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 1,
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    }

    const TypeIcon = () =>
        section.type === VIDEO ? <PlayArrowRounded /> : <DescriptionRounded />

    const showCircleRounded = () => {
        const { type, percentage } = section
        const isFullWatched = type === VIDEO && percentage === 100
        const isPassedTest = type === TEST && percentage !== null

        if (isFullWatched || isPassedTest) {
            return (
                <CheckCircleRounded
                    color="secondary"
                    sx={{ mr: 1 }}
                />
            )
        }
    }

    return (
        <Box
            sx={styles.wrapper}
            onClick={handleSelect}
        >
            <Box sx={styles.typeIcon}>
                <TypeIcon />
            </Box>

            <Box sx={{ width: '100%' }}>
                <Box sx={styles.title}>
                    <Box>{section.title}</Box>

                    <Box sx={styles.flexCenter}>
                        {showCircleRounded()}
                        {section.percentage ?? '0'}%
                    </Box>
                </Box>

                <LinearProgress
                    variant="determinate"
                    value={section.percentage}
                    color={'primary'}
                    sx={{ mt: 1 }}
                />
            </Box>
        </Box>
    )
}

export default Section
